var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 15C0.333008 6.89983 6.8995 0.333344 14.9997 0.333344C23.0999 0.333344 29.6663 6.89983 29.6663 15C29.6663 23.1002 23.0999 29.6667 14.9997 29.6667C6.8995 29.6667 0.333008 23.1002 0.333008 15Z",
    fill: "#884DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0806 9.72391C22.6013 10.2446 22.6013 11.0888 22.0806 11.6095L13.8045 20.2762C13.2838 20.7969 12.4395 20.7969 11.9188 20.2762L7.91884 16.2762C7.39815 15.7555 7.39815 14.9113 7.91884 14.3906C8.43954 13.8699 9.28376 13.8699 9.80446 14.3906L12.8617 17.4478L20.195 9.72391C20.7157 9.20321 21.5599 9.20321 22.0806 9.72391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5562afc61cb58101fd1a3678f65bc323.svg";
export { ForwardRef as ReactComponent };